<template>
  <div class="home">
    <div class="home-tab">
      <el-tabs
        v-model="activeName"
        @tab-click="handleClick"
      >
        <el-tab-pane
          v-for="(workFlow) in workFlowList"
          :key="workFlow.id"
          :label="workFlow.work_name"
          :name="workFlow.work_type"
        >
        </el-tab-pane>
      </el-tabs>
    </div>

    <div class="card-box">
      <div
        class="select-card"
        v-for="(categorie) in currentWorkFlowList.list"
        :key="categorie.id"
      >
        <h3
          :class="{
            click: categorie.list.length == 0
          }"
          @click="titleClick(categorie)"
        >
          {{ categorie.CategoryName }}
          <span>{{  categorie.list.length === 0 ? '' : `(${categorie.list.length})` }}</span>
        </h3>
        <div class="select-list">
          <div
            class="select-item"
            v-for="(child) in categorie.list"
            @click="goForm(child)"
            :key="child.id"
          >
            <van-icon
              v-if="child.IsHot"
              name="fire-o"
              color="#ee0a24"
              size="16px"
              style="margin-right: 5px;"
            />
            <!-- <svg
              class="icon"
              aria-hidden="true"
            >
              <use xlink:href="#icon-jieshao"></use>
            </svg> -->
            {{ child.CategoryName }}
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { Tabs, TabPane } from "element-ui";
import workService from "@/apis/work/index.js";
import { Icon } from "vant";

export default {
  name: "Home",
  components: {
    ElTabs: Tabs,
    ElTabPane: TabPane,
    VanIcon: Icon,
  },
  data() {
    return {
      activeName: "",
      workFlowList: [],
      currentWorkFlowList: [],
    };
  },
  created() {
    this.getList();
  },
  watch: {
    activeName: {
      handler(newVal) {
        console.log(newVal);
        const { workFlowList } = this;
        const activeName = newVal;
        workFlowList.forEach((workFlow) => {
          if (workFlow.work_type === activeName) {
            this.currentWorkFlowList = workFlow;
          }
        });
      },
    },
  },
  methods: {
    handleClick(tab) {
      console.log(tab);
    },
    getList() {
      workService.getWorkAddInit().then((res) => {
        let workFlowList = [];
        workFlowList = res.Types;
        workFlowList.forEach((workFlow) => {
          workFlow.list = [];
          res.Categories.forEach((categorie) => {
            if (
              workFlow.work_type === categorie.WorkTypeId &&
              categorie.ParentId === 0
            ) {
              categorie.list = [];
              res.Categories.forEach((child) => {
                if (categorie.Id === child.ParentId) {
                  categorie.list.push(child);
                }
              });
              workFlow.list.push(categorie);
            }
          });
        });

        this.workFlowList = workFlowList;
        this.activeName = workFlowList[0].work_type;
      });
    },
    goForm(categorie) {
      const query = this.$route.query;
      this.$router.push({
        name: "Form",
        params: {
          id: categorie.Id,
        },
        query: {
          ...query,
        },
      });
    },
    titleClick(categorie) {
      const query = this.$route.query;

      if (categorie.list.length === 0) {
        this.$router.push({
          name: "Form",
          params: {
            id: categorie.Id,
          },
          query: {
            ...query,
          },
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.home {
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: #fff;
  .home-tab {
    flex-shrink: 0;
  }
  .card-box {
    flex: 1;
    overflow-y: auto;
  }
  .select-card {
    border-bottom: 1px solid #e4e7ed;
    padding: 5px 20px;
    padding-bottom: 0;
    h3 {
      margin-top: 0;
      font-size: 16px;
      span {
        color: #e4e7ed;
      }
      &.click {
        cursor: pointer;
      }
    }
  }
  .select-list {
    display: flex;
    flex-wrap: wrap;
    .select-item {
      font-size: 12px;
      margin-bottom: 5px;
      cursor: pointer;
      display: flex;
      align-items: center;
      border: 1px solid #e4e7ed;
      width: 160px;
      height: 40px;
      padding: 0 20px;
      box-sizing: border-box;
      border-radius: 3px;
      margin-right: 5px;
      svg {
        font-size: 30px;
        margin-right: 5px;
      }
    }
  }
}
</style>

<style lang="scss">
.home {
  // .el-tabs__active-bar {
  //   height: 0;
  // }
  // .el-tabs__nav-wrap::after {
  //   height: 0;
  // }
  // .el-tabs__item {
  //   padding-left: 15px !important;
  //   padding-right: 15px !important;
  //   border-radius: 5px;
  //   line-height: 40px;
  //   background-color: #EAEBED;
  //   margin-right: 6px;
  //   &.is-active {
  //     background-color: #ECF5FF;
  //   }
  // }
  .el-tabs__nav-scroll {
    padding: 0 20px;
    overflow-x: auto;
  }
  .el-tabs__nav {
    // padding: 0 20px;
    padding-right: 30px;
    .el-tabs__item:last-child {
      padding-right: 20px;
    }
  }
}
</style>